var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoatPlayerSkipper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 323.45,
    height: 188.73,
    viewBox: "0 0 323.45 188.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BOAT_PLAYER",
    "data-name": "BOAT PLAYER",
    transform: "translate(-195.281 153.095)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "FOND_TRANSPARENT",
    "data-name": "FOND TRANSPARENT",
    width: 323.45,
    height: 188.73,
    transform: "translate(195.281 -153.095)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "BOAT_16",
    "data-name": "BOAT 16",
    transform: "translate(198.343 -78.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7525",
    "data-name": "Path 7525",
    d: "M310.025,314.909c3.37-.213,7.623-.475,12.563-.787,0,0,52.136-12.226,81.23-30.212-2.2-1.314-3.5-1.97-3.5-1.97C368.314,301.781,310.025,314.909,310.025,314.909Z",
    transform: "translate(-209.68 -266.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7526",
    "data-name": "Path 7526",
    d: "M444.9,307.456l11.664,13.408s5.752-1.215,13.59-2.938v-.016l-18.3-10.454Z",
    transform: "translate(-444.9 -255.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7527",
    "data-name": "Path 7527",
    d: "M457.062,307.456,468.1,320.141c-2.127.456-3.387.723-3.387.723l-11.664-13.408Z",
    transform: "translate(-453.048 -255.138)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7528",
    "data-name": "Path 7528",
    d: "M211.644,327.173l10.079,24.763c188.443,0,265.818-11.471,267.189-11.684h.014c18.317-12.883,26.5-28.029,35.348-29.9L274.058,323.809Z",
    transform: "translate(-206.947 -253.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7529",
    "data-name": "Path 7529",
    d: "M452.422,322.038l11.51,24.759c-1.6,0-1.284,0-2.9,0l-10.079-24.763Z",
    transform: "translate(-446.252 -248.731)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7530",
    "data-name": "Path 7530",
    d: "M211.644,328.663,461.86,315.206c-.586-.476-18.8-14.655-51.393-15.9h-.071C355.275,299.321,278.684,312.6,211.644,328.663Z",
    transform: "translate(-144.533 -258.72)",
    fill: "#ce6f3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7531",
    "data-name": "Path 7531",
    d: "M259.712,336.835s5.752-1.215,13.59-2.938c7.257-1.612,16.292-3.663,24.148-5.6a31.636,31.636,0,0,0,16.224-10.155c9.455-12.8,36.765-15.647,26.335-3.136l-.18,5.2s3.125-.2,8.565-.541c3.37-.213,7.623-.475,12.563-.787,26.739-1.658,73.607-4.448,109.239-6.056,16.49-.738,30.58-1.231,39.16-1.231,1.541,0,3.069.033,4.554.1-55.12.017-131.71,13.293-198.751,29.359l-62.414,3.364Z",
    transform: "translate(-248.048 -271.109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3434",
    "data-name": "Group 3434",
    transform: "translate(4.697 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7532",
    "data-name": "Path 7532",
    d: "M421.956,330.13c-5.95,1.468-24.5,4.947-33.289,7.44a22.984,22.984,0,0,0-8.438,4.5l-2.275,1.894-8.343.449,6.967-7.581s5.752-1.215,13.59-2.938c7.257-1.612,16.292-3.663,24.148-5.6a31.639,31.639,0,0,0,16.225-10.155C440.432,306.972,428.1,328.614,421.956,330.13Z",
    transform: "translate(-369.611 -271.109)",
    fill: "#e0e8f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7533",
    "data-name": "Path 7533",
    d: "M368.886,283.309c-29.094,17.985-81.23,30.212-81.23,30.212,26.739-1.658,73.607-4.448,109.239-6.056A112.274,112.274,0,0,0,368.886,283.309Z",
    transform: "translate(-174.748 -265.748)",
    fill: "#adebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7540",
    "data-name": "Path 7540",
    d: "M213.041,331.337l-1.344-3.3a.641.641,0,0,1,.476-.907l61.587-3.319,204.474-11h0l45.741-2.46c-8.852,1.871-17.032,17.018-35.348,29.9h-.014c-14.148,9.945-34.362,18.511-65.627,18.511H224.548a.552.552,0,0,1-.5-.367l-2.621-6.46c94.774,0,161.447-2.9,204.492-5.812a55.382,55.382,0,0,0,32.952-14.184c5.436-4.813,10.368-9.611,14.794-14.231.384-.4.108-1.129-.408-1.082-77.586,7.016-199.495,11.832-199.495,11.832L213.569,331.7A.55.55,0,0,1,213.041,331.337Z",
    transform: "translate(-206.65 -253.866)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7541",
    "data-name": "Path 7541",
    d: "M367.819,319.7s-35.962,6.2-115.074,12.39c0,0,82.324-1.54,113.256-6.2Z",
    transform: "translate(-101.958 -249.758)",
    fill: "#e0e8f5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatPlayerSkipper);
export default __webpack_public_path__ + "static/media/boat-player-skipper.9b327844.svg";
export { ForwardRef as ReactComponent };